import styled from "styled-components"
import {Row} from "react-bootstrap"

import Card from "@irati/ui/src/Layout/Card"
import {Label} from "@irati/ui/src/Typography"
import Button from "@irati/ui/src/Button"
import Icon from "@irati/ui/src/Icon"

interface LabelTooltipProps {
  isSingleTeam: boolean
}

interface LabelTooltipProps {
  isSingleTeam: boolean
}

interface SelectedQuadrantProps {
  selectedQuadrant: boolean
}

export const Wrapper = styled.div`
  min-height: 500px;
  .recharts-cartesian-grid-horizontal line:last-child {
    display: none;
  }
  .recharts-cartesian-grid-horizontal line:first-child {
    display: none;
  }
  .recharts-cartesian-grid-vertical line:last-child {
    display: none;
  }
  .recharts-cartesian-grid-vertical line:first-child {
    display: none;
  }
  .recharts-scatter circle:hover {
    filter: drop-shadow(0px 3px 3px rgba(0, 0, 0, 0.4));
  }
  .recharts-tooltip-wrapper {
    z-index: 1;
  }
  .recharts-reference-area, .recharts-scatter-symbol {
    cursor: pointer;
  }
  .recharts-label-list {
    display: none;
  }
`

export const ClickableCard = styled(Card)`
  min-width: 150px;
  pointer-events: all;
`

export const LabelTooltip = styled(Label)<LabelTooltipProps>`
  position: relative;
  bottom: 22px;
  left: 5px;
  ${({isSingleTeam, theme}) => isSingleTeam && `
    background: ${theme.colors.greys.white};
    border: 1px solid ${theme.colors.greys.white};
    border-radius: 5px;
  `}
`

export const Circle = styled.span`
  height: 20px;
  width: 20px;
  background-color: ${({theme}) => theme.colors.tertiary.b_200};
  border-radius: 50%;
  display: inline-block;
`

export const YAxisWrapper = styled.span`
  transform: rotate(-90deg);
  display: inline-block;
  position: relative;
  bottom: 280px;
  right: 60px;
`

export const XAxisWrapper = styled.span`
  position: absolute;
  left: 45%;
`

export const YAxisIcon = styled(Icon)`
  transform: rotate(+90deg);
  position: relative;
  top: 5px;
`
export const XAxisIcon = styled(Icon)`
  position: relative;
  top: 5px;
`

export const TeamSizeIcon = styled(Icon)`
  position: relative;
  bottom: 4px;
`

export const Text = styled.text`
  font-family: Lato, sans-serif;
  font-size: 14px;
  font-weight: 700;
`

export const SelectedQuadrantButton = styled(Button)<SelectedQuadrantProps>`
  ${({selectedQuadrant, theme}) => selectedQuadrant
    ? `
    color: ${theme.colors.primary2};
    background-color: ${theme.colors.utility.white};
    text-decoration: none;
  ` : `
    &:active, &:focus {
      color: ${theme.colors.utility.white};
      background-color: ${theme.colors.tertiary.b_400};
    }
  `}
`

export const FlexRow = styled(Row)`
  display: flex;
  align-items: center;
`
